export default __webpack_public_path__ + "static/individual.momo-13662ef92d284df9e9b0bb41fed47baa.png";